import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('a-card', {
    staticClass: "app-box",
    attrs: {
      "bordered": false
    }
  }, [_c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.isLoading
    }
  }, [_c('div', {
    staticClass: "logout-container"
  }, [_c('a-steps', {
    staticClass: "mb-40",
    attrs: {
      "current": _vm.current
    }
  }, [_c('a-step', {
    attrs: {
      "title": _vm.t('阅读注销须知')
    }
  }), _c('a-step', {
    attrs: {
      "title": _vm.t('确认注销')
    }
  }), _c('a-step', {
    attrs: {
      "title": _vm.t('完成')
    }
  })], 1), _c(_vm.stepContent[_vm.current], {
    tag: "component",
    on: {
      "next": _vm.handleNext
    }
  })], 1)])], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };